module.exports = __webpack_public_path__ + "static/media/gallery_009.99b5d986.webp";